import { Leadership } from '../../types/content';

/** Leadership 섹션. 3문장 + 팀원의 판단을 받아들인 사례 하나. 서술 문장은 합쇼체. */
export const leadership: Leadership = {
  situation:
    '2025년 10월부터 실질적으로 팀을 리딩하고 2026년 1월 팀장이 됐습니다. 인원 축소, 타 팀 전입, 채용, 온보딩이 같은 시기에 겹쳤고, 운영 범위는 그대로였습니다.',
  principle:
    '팀장이 된 뒤에도 파이프라인·API·데이터 맵을 직접 구현했습니다. 동시에 일이 특정 개인에 의존하지 않게 만드는 것을 팀장의 일로 받아들여, 주간·월간·스프린트 리듬, 그라운드 룰, 운영 매뉴얼, 온보딩 문서를 다시 세웠고, JD와 면접 질문을 직접 설계했습니다.',
  result:
    '운영 범위를 줄이지 않고 지켰습니다. 새 합류자가 문서로 온보딩했고, 팀원과 함께 외부 교육과 세미나에 나가 데이터 역량을 같이 올렸습니다. 팀을 맡은 뒤 사내 시각화 플랫폼의 월 평균 접속자가 전년 대비 약 네 배로 늘었습니다(GA 기준). 여러 개선, 올해 세 번의 출장에서 모은 피드백, 신규 기능 배포가 함께 작용한 결과입니다.',
  // 팀원 판단 사례는 단독 박스로 두면 하나만 있어 빈약해 보여, How I work 의 원칙(동료가 나보다 더 잘하게 만든다) 근거 문장으로 옮겼다.
  teamDecision: undefined,
  caseId: 'D'
};
